<template>
	<section class="section-table">
		<div class="header-table">
			<div class="search-container">
				<feather
					class="refreshtable"
					:class="isLoading === true ? 'animation-refresh' : 'stop'"
					type="refresh-cw"
					size="18px"
					@click="
						!isLoading
							? ((selected = {}), $emit('update-table', { limit: rowsperpage, offset: 0 }))
							: null
					"
				/>
				<search width="70%" height="35px" @searchtext="(searchTerm = $event), filter()" />
			</div>
			<div class="right-container">
				<div class="select-rows-qt">
					<select
						v-model="rowsperpagechange"
						class="select-container"
						title="Selecionar quantidade de linhas"
						@change="(rowsperpage = rowsperpagechange), $emit('pagelimit', rowsperpagechange)"
					>
						<option :value="10">
							10 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="30">
							30 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="50" selected>
							50 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="100">
							100 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
					</select>
				</div>
				<b-dropdown ref="dropdown" :disabled="typeof selected.id === 'undefined'" aria-role="list">
					<template #trigger="{ active }">
						<KButton
							slot="trigger"
							height="34px"
							title="Ações"
							:disabled="typeof selected.id === 'undefined'"
							width="unset"
							margin-left="10px"
							font-weight="400"
							:icon="{
								type: `${active ? 'chevron-up' : 'chevron-down'}`,
								size: '18px',
								color: '#28a745',
							}"
							font-size="0.8125rem"
							border-radius="0.25rem"
						/>
					</template>

					<b-dropdown-item
						:disabled="verifyAproveRules(selected.situacao_id)"
						aria-role="listitem"
						@click="
							selected.situacao_id === 11
								? $emit('payment-manual', selected)
								: $emit('openModal', selected.id)
						"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						:disabled="verifyCancelRules(selected.situacao_id)"
						aria-role="listitem"
						@click="$emit('cancel', selected)"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon danger" type="x" size="16" />
							<h1>Cancelar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem" @click="$emit('add-observation', selected)">
						<div class="menu-row-option">
							<feather class="menu-row-icon archive" type="paperclip" size="16" />
							<h1>Adicionar Observação</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						@click="
							$emit('viewmore', {
								id: selected.pedido_id,
								gateway: selected.gateway === 'Getnet' ? 1 : 2,
							})
						"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon check" type="credit-card" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						@click="$router.push(`/order/${selected.pedido_id}/details`)"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon check" type="truck" size="16" />
							<h1>Detalhes do Pedido</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>
				<Export :data="data" :filters="filterCartao" />
				<kfilter
					:filter-visibility="filterVisibility"
					@open-filter="filterVisibility = true"
					@apply="(filterVisibility = !filterVisibility), filter()"
					@clear="clearFilter()"
				>
					<template v-slot:container>
						<div class="container-filter">
							<div class="situation-box">
								<b-checkbox
									v-model="dataPagamentoCheckbox"
									size="is-small"
									class="checkbox-situation"
									:disabled="verifySituation()"
								>
									Data de Pagamento
								</b-checkbox>
								<div v-if="dataPagamentoCheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-input">
										<b-input
											v-model="dtpagamento.startDate"
											type="date"
											size="is-small"
											class="input-date-picker"
										/>
										<b-input
											v-model="dtpagamento.endDate"
											type="date"
											size="is-small"
											class="input-date-picker"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="situationpedidocheck"
									size="is-small"
									class="checkbox-situation-pedido"
									:disabled="verifySituation()"
								>
									Situação do Pedido
								</b-checkbox>
								<div v-if="situationpedidocheck" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pedido-input">
										<treeselect
											v-model="situationpedido"
											class="treeselectcheck"
											:multiple="true"
											:options="situacaoPedidoOptions"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pagamento-box">
								<b-checkbox
									v-model="situationpagamentocheck"
									size="is-small"
									class="checkbox-situation-pagamento"
								>
									Situação do Pagamento
								</b-checkbox>
								<div v-if="situationpagamentocheck" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pagamento-input">
										<treeselect
											v-model="situationpagamento"
											class="treeselectcheck"
											:multiple="true"
											:options="situacaoOptions"
										/>
									</div>
								</div>
							</div>

							<div class="situation-pagamento-box">
								<b-checkbox
									v-model="situationcondpagamento"
									size="is-small"
									class="checkbox-situation-pagamento"
									:disabled="verifySituation()"
								>
									Condição de Pagamento
								</b-checkbox>
								<div v-if="situationcondpagamento" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pagamento-input">
										<treeselect
											v-model="situationcondpagamentod"
											class="treeselectcheck"
											:multiple="true"
											:options="condpagamentooptions"
										/>
									</div>
								</div>
							</div>
						</div>
					</template>
				</kfilter>
			</div>
		</div>
		<b-table
			v-if="data.length > 0"
			ref="table"
			:data="data"
			paginated
			focusable
			:narrowed="true"
			:per-page="rowsperpage"
			:selected.sync="selected"
			:loading="isLoading"
			sticky-header
			pagination-size="is-small"
			backend-pagination
			backend-sorting
			:current-page="currentPage"
			:total="totalpages"
			striped
			@sort="(orderby, direction) => filter(orderby, direction)"
			@page-change="pageChange($event)"
		>
			<b-table-column label="Ações" header-class="custom-header" centered>
				<b-dropdown ref="dropdown" :disabled="typeof selected.id === 'undefined'" aria-role="list">
					<template>
						<h1 slot="trigger" class="row-actions-circles">
							<div class="circle" />
							<div class="circle" />
							<div class="circle" />
						</h1>
					</template>

					<b-dropdown-item
						:disabled="verifyAproveRules(selected.situacao_id)"
						aria-role="listitem"
						@click="
							selected.situacao_id === 11
								? $emit('payment-manual', selected)
								: $emit('openModal', selected.id)
						"
					>
						<div class="menu-row-option">
							<feather
								class="menu-row-icon check"
								:type="selected.situacao_id === 11 ? 'shield' : 'check'"
								size="16"
							/>
							<h1>{{ selected.situacao_id === 11 ? 'Autorizar Pagamento' : 'Aprovar' }}</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						:disabled="verifyCancelRules(selected.situacao_id)"
						aria-role="listitem"
						@click="$emit('cancel', selected)"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon danger" type="x" size="16" />
							<h1>Cancelar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem" @click="$emit('add-observation', selected)">
						<div class="menu-row-option">
							<feather class="menu-row-icon archive" type="paperclip" size="16" />
							<h1>Adicionar Observação</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						@click="
							$emit('viewmore', {
								id: selected.pedido_id,
								gateway: selected.gateway === 'Getnet' ? 1 : 2,
							})
						"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon archive" type="credit-card" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						@click="$router.push(`/order/${selected.pedido_id}/details`)"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon check" type="truck" size="16" />
							<h1>Detalhes do Pedido</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="id"
				label="Cod. Pgto"
				numeric
				sortable
				header-class="custom-header"
			>
				<h1 :ref="'a' + props.row.id" class="row-text">
					{{ props.row.id }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="situacao_id"
				label="Sit. Pgto"
				header-class="custom-header"
				sortable
			>
				<Situacao :data="props.row.situacao_id" />
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="pedido_id"
				label="Cod. Pedido"
				header-class="custom-header"
				sortable
				numeric
				centered
			>
				<h1 class="row-text">
					{{ props.row.pedido_id }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="payment_nsu"
				label="NSU"
				header-class="custom-header"
				sortable
				numeric
				centered
			>
				<h1 class="row-text">
					{{ props.row.payment_nsu ? props.row.payment_nsu : '~' }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="pedido_integracao_id"
				label="Cod. Ped. Itg"
				header-class="custom-header"
				centered
				sortable
			>
				<h1 class="row-text">
					{{ props.row.pedido_integracao_id ? props.row.pedido_integracao_id : '~' }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="pedido_situacao"
				label="Sit. Pedido"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.pedido_situacao }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="vlrpago"
				label="Vlr. Pago"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.formatedBrl }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="vlrcaptura"
				label="Vlr. Captura"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.vlrcaptura ? transformToBrl(props.row.vlrcaptura) : '~' }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="dtpagamento"
				label="Dta. Pagamento"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ dateTimetoDate(props.row.dtpagamento) }}
				</h1>
				<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.dtpagamento) }}</h2>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="dtcaptura"
				label="Dta. Captura"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ dateTimetoDate(props.row.dtcaptura) }}
				</h1>
				<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.dtcaptura) }}</h2>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="condpgto_descricao"
				label="Cond. Pgto"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.condpgto_descricao }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="gateway"
				label="Gateway"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.gateway ? props.row.gateway : '~' }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="tabvnd_desc"
				label="Tabela"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.tabvnd_desc ? props.row.tabvnd_desc : '~' }}
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				field="empresa_fantasia"
				label="Empresa"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.empresa_fantasia ? props.row.empresa_fantasia : '~' }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="nomerazao"
				label="Cliente"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.nomerazao }}
				</h1>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="cpfcnpj"
				label="CPF/CNPJ"
				header-class="custom-header"
				sortable
			>
				<h1 class="row-text">
					{{ props.row.cpfcnpj }}
				</h1>
			</b-table-column>
		</b-table>
		<Empty
			v-if="data.length <= 0 && isLoading === false"
			message="Nenhum item encontrado"
			subtitle="Tente alterar os filtros"
		/>
	</section>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
/* import VueContext from 'vue-context'; */
import cookie from 'vue-cookie';
import jwtdecode from 'jwt-decode';
import global from '../../../mixins/global';
import search from '../search/index';
import kfilter from '../filter/custom';
import Situacao from '../tags/StatusCard';
import Export from '../miscellaneous/export';
import 'vue-context/src/sass/vue-context.scss';
import Empty from '../empty';
import KButton from '../buttons/Default';

export default {
	components: {
		/*   VueContext, */
		Export,
		search,
		kfilter,
		Situacao,
		Treeselect,
		Empty,
		KButton,
	},
	mixins: [global],
	props: {
		condpagamentooptions: {
			type: Array,
			default: () => [],
		},
		data: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		totalpages: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			searchTerm: null,
			rowsperpageCustom: 0,
			userAuthorizedId: null,
			rowsperpage: 50,
			rowsperpagechange: 50,
			userPageStatus: 50,
			situationcheckbox: false,
			situationpedidocheck: false,
			situationpedido: [],
			situationcondpagamento: false,
			situationcondpagamentod: [],
			situationpagamento: [],
			situationpagamentocheck: false,
			situation: [],
			filterVisibility: false,
			defaultOpenedDetails: [1],
			selected: {},
			situacaoOptions: [
				{
					id: 1,
					label: '1 - Pendente',
				},
				{
					id: 2,
					label: '2 - Cancelado',
				},
				{
					id: 3,
					label: '3 - Concluido',
				},
				{
					id: 4,
					label: '4 - Aguardando avaliação manual',
				},
				{
					id: 5,
					label: '5 - Aguardando captura',
				},
				{
					id: 6,
					label: '6 - Captura em andamento',
				},
				{
					id: 7,
					label: '7 - Em alerta',
				},
				{
					id: 8,
					label: '8 - Aguardando cancelamento',
				},
				{
					id: 9,
					label: '9 - Cancelamento em andamento',
				},
				{
					id: 10,
					label: '10 - Cancelamento aceito, aguardando',
				},
				{
					id: 11,
					label: '11 - Não Autorizado',
				},
			],
			situacaoPedidoOptions: [
				{
					id: 0,
					label: '0 - Salvo',
				},
				{
					id: 1,
					label: '1 - Finalizado',
				},
				{
					id: 2,
					label: '2 - Integrado',
				},
				{
					id: 3,
					label: '3 - Inválido',
				},
				{
					id: 4,
					label: '4 - Em análise',
				},
				{
					id: 5,
					label: '5 - Liberado',
				},
				{
					id: 6,
					label: '6 - Faturado',
				},
				{
					id: 7,
					label: '7 - Cancelado',
				},
				{
					id: 8,
					label: '8 - Transporte',
				},
				{
					id: 9,
					label: '9 - Entregue',
				},
				{
					id: 10,
					label: '10 - Aguardando Pagamento',
				},
				{
					id: 11,
					label: '11 - Em rota',
				},
			],
			activeChanged: true,
			dtpagamento: {
				startDate: '',
				endDate: '',
			},
			dataPagamentoCheckbox: false,
		};
	},
	computed: {
		filterCartao() {
			const cardFilter = JSON.parse(localStorage.getItem('filter-cartao'));
			return cardFilter;
		},
	},
	watch: {
		dataPagamentoCheckbox(check) {
			if (check === false) {
				this.dtpagamento = { startDate: '', endDate: '' };
			}
		},
		rowsperpagechange() {
			this.pageChange(this.lastpage);
		},

		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
	},
	created() {
		if (localStorage.getItem('filter-cartao')) {
			const storeData = JSON.parse(localStorage.getItem('filter-cartao'));
			const {
				dataPagamentoCheckbox,
				situationpedidocheck,
				situationpedido,
				situationpagamentocheck,
				situationpagamento,
				situationcondpagamento,
				situationcondpagamentod,
				dtpagamento,
			} = storeData;
			if (dtpagamento) {
				this.dataPagamentoCheckbox = dataPagamentoCheckbox;
				this.dtpagamento = dtpagamento;
			}
			this.situationpedidocheck = situationpedidocheck;
			this.situationpedido = situationpedido;
			this.situationpagamentocheck = situationpagamentocheck;
			this.situationpagamento = situationpagamento;
			this.situationcondpagamento = situationcondpagamento;
			this.situationcondpagamentod = situationcondpagamentod;
		}
		this.filter();
		this.pageChange(1);
		this.userAuthorizedId = this.jwtDecoded().sub;
		let userArrayPermissions = api.env.AUTHORIZED_USERS;
		userArrayPermissions = userArrayPermissions.split('/');
		this.isAuthorizedUser = 1; // userArrayPermissions.findIndex(
		//	(item) => parseInt(item, 10) === this.userAuthorizedId
		// );
	},
	methods: {
		verifySituation() {
			const data = JSON.parse(localStorage.getItem('filter-cartao'));
			if (data.situacao && data.situacao[0] === 11) {
				return true;
			}
			return false;
		},
		verifyCancelRules(situacaoid) {
			if (
				situacaoid === 2 ||
				situacaoid === 8 ||
				situacaoid === 9 ||
				situacaoid === 10 ||
				situacaoid === 11 ||
				this.isAuthorizedUser === -1
			) {
				return true;
			}
			return false;
		},
		verifyAproveRules(situacaoid) {
			if (
				situacaoid === 3 ||
				situacaoid === 5 ||
				situacaoid === 6 ||
				situacaoid === 9 ||
				situacaoid === 10 ||
				this.isAuthorizedUser === -1
			) {
				return true;
			}
			return false;
		},
		jwtDecoded() {
			let decoded = '';
			if (
				cookie.get('admtoken', {
					host: window.location.host,
				}) !== null
			) {
				const token = cookie.get('admtoken', {
					host: window.location.host,
				});
				decoded = jwtdecode(token);
			}
			return decoded;
		},
		notification(message) {
			this.$buefy.notification.open({
				message,
				type: 'is-warning',
			});
		},
		pageChange(pagenumber) {
			const offset = pagenumber * this.rowsperpagechange - this.rowsperpagechange;
			this.$emit('pagechange', { limit: this.rowsperpagechange, offset, pagenumber });
			this.lastpage = pagenumber;
			this.rowsperpageCustom = pagenumber * this.rowsperpagechange + 1;
			this.userPageStatus = this.rowsperpageCustom - this.rowsperpagechange;
		},

		// eslint-disable-next-line no-unused-vars
		showContext(row = null, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context);
		},
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		filterStore(filterDate) {
			const {
				// eslint-disable-next-line camelcase
				pedido_situacao,
				situacao,
				condpgto,
				searchTerm,
				dataPagamento,
				orderby,
				direction,
			} = filterDate;
			const storeFilter = {
				dataPagamentoCheckbox: this.dataPagamentoCheckbox,
				situationpedidocheck: this.situationpedidocheck,
				situationpedido: this.situationpedido,
				situationpagamentocheck: this.situationpagamentocheck,
				situationpagamento: this.situationpagamento,
				situationcondpagamento: this.situationcondpagamento,
				situationcondpagamentod: this.situationcondpagamentod,
				dtpagamento: dataPagamento,
				pedido_situacao,
				situacao,
				condpgto,
				searchTerm,
				orderby,
				direction,
			};
			localStorage.setItem('filter-cartao', JSON.stringify(storeFilter));
		},
		clearFilter() {
			this.dataPagamentoCheckbox = false;
			this.dtpagamento = {
				startDate: '',
				endDate: '',
			};
			this.situationpedidocheck = false;
			this.situationpedido = [];
			this.situationpagamentocheck = false;
			this.situationpagamento = [];
			this.situationcondpagamento = false;
			this.situationcondpagamentod = [];

			this.filter();
		},
		filter(orderby, direction) {
			let sendDtaPagamento = null;
			let sendSituationpedido = null;
			let sendPagamento = null;
			let situationcondpg = null;
			let searchTerm = null;
			if (
				this.dtpagamento &&
				this.dataPagamentoCheckbox !== false &&
				this.dtpagamento.startDate !== '' &&
				this.dtpagamento.endDate !== '' &&
				this.dtpagamento.endDate !== undefined &&
				this.dtpagamento.endDate !== undefined
			) {
				sendDtaPagamento = {
					startDate: `${this.dtpagamento.startDate}`,
					endDate: `${this.dtpagamento.startDate}`,
				};
			}
			if (this.situationpedidocheck !== false && this.situationpedido.length > 0) {
				sendSituationpedido = this.situationpedido;
			}
			if (this.situationpagamentocheck !== false && this.situationpagamento.length > 0) {
				sendPagamento = this.situationpagamento;
			}
			if (this.situationcondpagamento !== false && this.situationcondpagamentod.length > 0) {
				situationcondpg = this.situationcondpagamentod;
			}

			if (this.searchTerm) {
				searchTerm = this.searchTerm;
			}

			const filterDate = {
				dataPagamento: this.dtpagamento,
				dtpagamento: sendDtaPagamento,
				pedido_situacao: sendSituationpedido,
				situacao: sendPagamento,
				condpgto: situationcondpg,
				searchTerm,
				direction,
				orderby,
			};
			this.filterStore(filterDate);
			this.$emit('filterApply', { limit: this.rowsperpage, offset: 0 });
		},
	},

	/*
      1 = Pendente
      2 = Cancelado
      3 = Concluído
      4 = Aguardando Avaliação Manual
      5 = Aguardando captura
      6 = Captura em andamento
      7 = Em alerta
      8 = Aguardando cancelamento
      9 = Cancelamento em andamento
      10 = Cancelamento aceito, aguardando
   */
};
</script>
<style lang="scss" scoped>
.section-table {
	display: flex;
	width: 100% !important;
	flex-direction: column;
	height: 100%;
	padding: 13px;
	background-color: #fff;
	box-shadow: -1px 12px 18px 0 #dadee8;
	border-radius: 5px;
	margin-bottom: 20px;
}
.circle {
	width: 4px;
	height: 4px;
	margin: 1px;
	border-radius: 50%;
	background-color: rgb(212, 212, 212);
	transition: ease-in-out 0.5s;
}

.search-container {
	width: 60%;
	display: flex;
	align-items: center;
}
.animation-refresh {
	-webkit-animation: rotating 2s linear infinite;
	-moz-animation: rotating 2s linear infinite;
	-ms-animation: rotating 2s linear infinite;
	-o-animation: rotating 2s linear infinite;
	animation: rotating 2s linear infinite;
}

@keyframes rotating {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
.refreshtable {
	margin-right: 20px;
	color: #00c9a7;
	cursor: pointer;
}
.row-actions-circles {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
}
.row-actions-circles:hover {
	cursor: pointer;
}
.row-actions-circles:hover .circle {
	background-color: rgb(139, 139, 139);
}

.row-text {
	display: flex;
	color: $row-color;
	font-weight: $row-weight;
	font-size: $row-size !important;
	margin-top: 5px;
	margin-bottom: 2px;
	font-size: 0.7rem;
}
.table td,
.table th {
	padding: 0.15em 0.3em !important;
}
.custom-header {
	font-size: $header-size;
	font-weight: $header-weight;
	color: $header-color;
}
.header-table {
	display: flex;
	background-color: #fff;
	padding: 20px;
	justify-content: space-between;
}
.container-detail {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
}
.situation-pagamento-box {
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	padding-bottom: 10px;
	padding-top: 10px;
}
.situation-pedido-box {
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	padding-bottom: 10px;
}
.grouped-situation-pagamento-input {
	display: flex;
	width: 100%;
	align-items: center;
	margin-left: 4px;
}
.grouped-situation-pedido-input {
	display: flex;
	width: 100%;
	align-items: center;
	margin-left: 4px;
}
.checkbox-situation {
	padding: 15px 15px 0px 0;
	width: 100%;
}
.select-pagamento-situation {
	display: flex;
	width: 100%;
}
.select-ped-situation {
	display: flex;
	width: 100%;
}
.situation-box {
	padding: 15px 15px 15px 0;
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	margin-bottom: 10px;
}
.input-date-picker {
	width: 50%;
}
.input-date-picker:first-child {
	margin-right: 4px;
	margin-left: 4px;
}
.grouped-situation-input {
	display: flex;
	width: 89%;
	justify-content: space-between;
}

.situation-box-input {
	align-items: center;
	display: flex;
	margin-top: 7px;
}
.exapanded-box {
	width: 30%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: row;
	border: 1px solid #6d5bd042;
	border-radius: 5px;
	padding: 10px;
}
.right-container {
	display: flex;
	align-items: center;
}
.arrow-indicator {
	color: #6d5bd0;
}
.exapanded-box h1 {
	padding: 5px;
	color: rgb(0, 0, 0);
}
.exapanded-box h1:last-child {
	font-size: 12px;
}
.icon-expanded-box {
	font-size: 25px;
	padding: 5px;
	margin-right: 15px;
}

/** Context Menu */

.menu-row-icon {
	color: #8b83ba;
	padding-left: 10px;
	padding-right: 10px;
	font-weight: 500;
}

.menu-row-box-bottom {
	padding-top: 10px;
}
.menu-row-box {
	padding-bottom: 10px;
	border-bottom: 1px solid #f2f0f9;
}
.menu-row-option:hover {
	color: #25213b !important;
	border-radius: 5px;
}

.menu-row-option:hover .danger {
	color: #dc3545 !important;
}

.menu-row-option:hover .check {
	color: #007f00;
}

.menu-row-option:hover .archive {
	color: #f77f00;
}

.menu-row-option {
	display: flex;
	align-items: center;
	padding: 10px;
	width: 100%;
	height: 100%;
	cursor: pointer;
}
.select-container {
	all: unset;
	border-radius: 0.25rem;
	cursor: pointer;
	border: 1px solid #e2e2e2;
	padding-top: 7px;
	padding-bottom: 7px;
	padding-left: 15px;
	padding-right: 15px;
	font-size: 12px;
	color: rgb(98, 98, 98);
}
</style>

